<template>
    <div>
        <div class="widget-item product-widget" v-for="(product, key) in products" :key="key">
            <h2>{{product.title}}</h2>
            <p>{{product.excerpt}}</p>
            <div class="item-image">
                <img :src="product.image" alt="">
            </div>
            <router-link :to="$i18nRoute({name: 'product', params: {product: product.id}})"><button class="button light dark-bordered">{{$t("buy_now")}}</button></router-link>
        </div>
    </div>
</template>

<script>
  import Subscribe from '@/components/home/Subscribe.vue';
  export default {
    components: {
      Subscribe
    },
    props: ['products'],
    data () {
      return {}
    }
  }
</script>

<style lang="scss">
    .product-widget{
        h2{
            margin: 0;
            font-family: $font-bold;
            font-size: 24px;
        }
        p{
            font-size: 16px;
        }
        .item-image{
            img{
                width: 100%;
                height: 250px;
                object-fit: cover;
            }
        }
        .button{
            width: 100%;
            margin-top: 20px;
        }
    }
</style>
